var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ChoicesOrder, } from "../types/forms";
export var MATRIX_SEPARATOR_CHARACTER = ".";
export var MATRIX_DYNAMIC_DEFAULT_ROWS = 2;
export var MATRIX_DYNAMIC_DEFAULT_MAX_ROWS = 1000;
export var COMMENT_FIELD_SUFFIX = "-Comment";
export var firstLetterToUpperCase = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
export var reorderChoices = function (choices, orderBy) {
    switch (orderBy) {
        case ChoicesOrder.ASC:
            return choices.sort(function (a, b) { return a.text.localeCompare(b.text); });
        case ChoicesOrder.DESC:
            return choices.sort(function (a, b) { return b.text.localeCompare(a.text); });
        case ChoicesOrder.RANDOM:
            return choices.sort(function () { return Math.random() - 0.5; });
        default:
            return choices;
    }
};
export var scrollToTop = function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
};
var SAFE_URL_PROTOCOLS = ["http:", "https:"];
export var sanitizeNavigateToUrl = function (url) {
    if (!url)
        return null;
    try {
        var parsed = new URL(url);
        return SAFE_URL_PROTOCOLS.includes(parsed.protocol) ? parsed.href : null;
    }
    catch (_a) {
        return null;
    }
};
export var compareTwoArraysEqual = function (_a) {
    var array1 = _a.array1, array2 = _a.array2, _b = _a.orderMatter, orderMatter = _b === void 0 ? false : _b;
    if (array1.length !== array2.length)
        return false;
    var sorted1 = array1;
    var sorted2 = array2;
    if (!orderMatter) {
        sorted1 = __spreadArray([], array1, true).sort();
        sorted2 = __spreadArray([], array2, true).sort();
    }
    // eslint-disable-next-line eqeqeq
    return sorted1.every(function (value, index) { return value == sorted2[index]; });
};
export var compareTwoArraysNotEqual = function (_a) {
    var array1 = _a.array1, array2 = _a.array2, _b = _a.orderMatter, orderMatter = _b === void 0 ? false : _b;
    if (array1.length !== array2.length)
        return true;
    var sorted1 = array1;
    var sorted2 = array2;
    if (!orderMatter) {
        sorted1 = __spreadArray([], array1, true).sort();
        sorted2 = __spreadArray([], array2, true).sort();
    }
    // eslint-disable-next-line eqeqeq
    return sorted1.some(function (value, index) { return value != sorted2[index]; });
};
export var handleReloadPageAfterSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 3000); })];
            case 1:
                _a.sent();
                window.location.reload();
                return [2 /*return*/];
        }
    });
}); };
export var compareTwoValuesEquals = function (value1, value2) {
    if (Array.isArray(value1) && Array.isArray(value2)) {
        var formattedValue1 = value1.map(function (item) { return String(item); });
        var formattedValue2 = value2.map(function (item) { return String(item); });
        return compareTwoArraysEqual({
            array1: formattedValue1,
            array2: formattedValue2,
        });
    }
    return String(value1) === String(value2);
};
export var isNumericValue = function (value) {
    if (typeof value === "number") {
        return Number.isFinite(value);
    }
    if (typeof value === "string") {
        var trimmed = value.trim();
        return trimmed.length > 0 && !Number.isNaN(Number(trimmed));
    }
    return false;
};
export var parseFlexibleNumericValue = function (value) {
    var _a;
    if (Array.isArray(value)) {
        return value.map(parseFlexibleNumericValue).reduce(function (a, b) { return a + b; }, 0);
    }
    if (typeof value === "number") {
        return Number.isFinite(value) ? value : 0;
    }
    var isBooleanValue = typeof value === "boolean";
    if (isBooleanValue) {
        return value ? 1 : 0;
    }
    if (typeof value !== "string") {
        return 0;
    }
    var trimmed = value.trim();
    var FLEXIBLE_NUMERIC_PATTERN = /^-?[\d.,]+$/;
    if (trimmed === "" || !FLEXIBLE_NUMERIC_PATTERN.test(trimmed)) {
        return 0;
    }
    var hasComma = trimmed.includes(",");
    var hasDot = trimmed.includes(".");
    if (hasComma && hasDot) {
        var lastComma = trimmed.lastIndexOf(",");
        var lastDot = trimmed.lastIndexOf(".");
        var normalized = lastComma > lastDot
            ? trimmed.replace(/\./g, "").replace(",", ".")
            : trimmed.replace(/,/g, "");
        return Number(normalized);
    }
    if (hasComma) {
        return Number(trimmed.replace(",", "."));
    }
    if (hasDot) {
        var dotCount = ((_a = trimmed.match(/\./g)) !== null && _a !== void 0 ? _a : []).length;
        if (dotCount > 1) {
            return Number(trimmed.replace(/\./g, ""));
        }
        var dotIndex = trimmed.indexOf(".");
        var beforeDot = trimmed.slice(0, dotIndex);
        var afterDot = trimmed.slice(dotIndex + 1);
        var dotAsThousandsSeparator = afterDot.length === 3 &&
            beforeDot.length >= 1 &&
            beforeDot.length <= 3 &&
            /^\d+$/.test(beforeDot) &&
            /^\d+$/.test(afterDot);
        if (dotAsThousandsSeparator) {
            return Number(beforeDot + afterDot);
        }
        return Number(trimmed);
    }
    return Number(trimmed);
};
export var getElementValueKey = function (element) { var _a; return (_a = element.valueName) !== null && _a !== void 0 ? _a : element.name; };
export var generateChoicesFromRange = function (max, min, step) {
    if (min === void 0) { min = 0; }
    if (step === void 0) { step = 1; }
    if (step <= 0 || min > max) {
        return [];
    }
    var generated = [];
    for (var value = min; value <= max; value += step) {
        generated.push({ value: String(value), text: String(value) });
    }
    return generated;
};
export var isValueFilled = function (value) {
    if (value === undefined || value === null) {
        return false;
    }
    if (typeof value === "string") {
        return value.trim().length > 0;
    }
    if (typeof value === "number" || typeof value === "boolean") {
        return true;
    }
    if (Array.isArray(value)) {
        if (value.length === 0) {
            return false;
        }
        return value.some(function (item) { return isValueFilled(item); });
    }
    if (typeof value === "object") {
        var obj = value;
        var keys = Object.keys(obj);
        if (keys.length === 0) {
            return false;
        }
        return Object.values(obj).every(function (item) { return isValueFilled(item); });
    }
    return true;
};
export var isOutOfRangeValidation = function (value, min, max) {
    var hasMin = min !== undefined;
    var hasMax = max !== undefined;
    var outOfMin = hasMin && value < min;
    var outOfMax = hasMax && value > max;
    return {
        isInvalid: outOfMin || outOfMax,
        safeMin: min !== null && min !== void 0 ? min : 0,
        safeMax: max !== null && max !== void 0 ? max : 0,
        hasMin: hasMin,
        hasMax: hasMax,
    };
};
